import React from 'react';
import telemedProfile from './images/telemedProfile.jpg';
import './css/style.scss';
import LazyImage from '../../../CustomLibraries/LazyImage';
const ShareTelemedDnrCard = ({
  isDnr,
  imgsrc,
  description,
  focusInput,
  telemedImg,
  text,
  headingCard
}) => {
  return (
    <div className="w-100 float-start dnrTelemedShareCardV1Box rounded-3 overflow-hidden">
      <span className="graph-1" style={{ backgroundColor: '#355fd3' }}></span>
      <span className="graph-2" style={{ backgroundColor: '#355fd3' }}></span>

      <div className="w-100 float-start dnrTelemedShareCardV1BoxPic">
        {isDnr ? (
          <LazyImage
            src={imgsrc}
            alt="banner"
            className="object-fit-cover w-100 h-100 float-start"
          />
        ) : (
          <LazyImage
            src={telemedImg}
            className="object-fit-cover w-100 h-100 float-start"
            alt="banner"
          />
        )}

        <div className="overlay"></div>
      </div>
      <div className="w-100 float-start dnrTelemedShareCardV1Btm">
        <div className="w-100 float-start d-flex text-start cardV1Topic">
          <div className="cardV1TopicContent">
            <h2 className="text-black fs-16 fw-medium mb-2">{headingCard}</h2>
            <p className="text-dark fs-4 fw-normal">{text}</p>
          </div>
        </div>

        <div className="w-100 float-start cardV1Ftr d-flex align-items-center justify-content-between">
          <span>&nbsp;</span>

          {isDnr ? (
            <div
              className="cardV1FtrBtn fs-4 fw-normal rippleEffect rounded cursorPointer"
              onClick={focusInput}
            >
              <div className="cardV1BtnHover" style={{ backgroundColor: '#355fd3' }}></div>
              <div className="cardV1BtnBorder rounded" style={{ borderColor: '#355fd3' }}></div>
              <span style={{ color: '#355fd3' }}>
                Begin
                <svg strokeWidth="0" viewBox="0 0 24 24" className="fs-2 fs-2 ms-2">
                  <path
                    d="M23.0677 11.9929L18.818 7.75739L17.4061 9.17398L19.2415 11.0032L0.932469 11.0012L0.932251 13.0012L19.2369 13.0032L17.4155 14.8308L18.8321 16.2426L23.0677 11.9929Z"
                    fill="currentColor"
                  ></path>
                </svg>
              </span>
            </div>
          ) : (
            <a
              className="cardV1FtrBtn fw-medium rippleEffect rounded cursorPointer"
              href="https://www.clirnet.com/telemed-lite"
            >
              <div className="cardV1BtnHover" style={{ backgroundColor: '#355fd3' }}></div>
              <div className="cardV1BtnBorder rounded" style={{ borderColor: '#355fd3' }}></div>
              <span style={{ color: '#355fd3' }}>
                Begin
                <svg strokeWidth="0" viewBox="0 0 24 24" className="fs-2 fs-2 ms-2">
                  <path
                    d="M23.0677 11.9929L18.818 7.75739L17.4061 9.17398L19.2415 11.0032L0.932469 11.0012L0.932251 13.0012L19.2369 13.0032L17.4155 14.8308L18.8321 16.2426L23.0677 11.9929Z"
                    fill="currentColor"
                  ></path>
                </svg>
              </span>
            </a>
          )}
        </div>
      </div>
    </div>
  );
};

export default ShareTelemedDnrCard;

// <a href="https://www.clirnet.com/telemed-lite" />
